var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 400 400"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.79 362.53c150.94 0 233.5-125.06 233.5-233.5 0-3.552 0-7.088-.24-10.608a166.98 166.98 0 0040.944-42.48 163.81 163.81 0 01-47.136 12.912 82.352 82.352 0 0036.08-45.392 164.46 164.46 0 01-52.112 19.92 82.144 82.144 0 00-139.86 74.848 232.99 232.99 0 01-169.14-85.744 82.128 82.128 0 0025.408 109.55 81.456 81.456 0 01-37.248-10.272v1.04a82.096 82.096 0 0065.84 80.448 81.936 81.936 0 01-37.056 1.408 82.16 82.16 0 0076.672 56.992 164.67 164.67 0 01-101.92 35.2 167.06 167.06 0 01-19.536-1.184 232.34 232.34 0 00125.79 36.8"
  })));
};

export default SvgTwitter;